<template>
  <VRow no-gutters class="pt-6">
    <VCol cols="12">
      <SBtn
        block
        action
        class="pointer"
        color="secondary"
        data-testid="shop-button"
        @click="routeToContinueShopping"
      >
        {{ $t('btn.continueShopping') }}
      </SBtn>
    </VCol>
    <VCol cols="12" class="text-center pt-1">
      <SBtn
        link-small
        class="mt-3 font-weight-medium"
        data-testid="cart-button"
        @click="routeToCart"
      >
        {{  $t('notifications.item-added.btn.view-basket') }}
      </SBtn>
    </VCol>
  </VRow>
</template>

<script lang="ts" setup>
import { CART_PATH } from '~/utils/cartRoutes'

const emits = defineEmits<{
  (e: 'view-cart' | 'terminate-notification'): void
}>()


const router = useRouter()
const { shopRootPath } = useCategoryUrl()

const routeToContinueShopping = () => {
  router.push(shopRootPath.value)
  emits('terminate-notification')
}

const routeToCart = () => {
  router.push(CART_PATH)
  emits('terminate-notification')
}
</script>

<style lang="scss" scoped>
:deep(.action-button.bg-secondary:hover) {
  background-color: #C4126B; // slightly darker secondary
}
</style>
